module.exports = __webpack_public_path__ + "static/img/pitch_black_wide.1afb81e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_black_wide.png
// module id = HSxZ
// module chunks = 94